import { FC, ReactNode, SVGProps, useMemo } from 'react';

import CurrentTimeLine from '@/apps/mwd-v2/components/Timescale/CurrentTimeLine';
import Timeline from '@/apps/mwd-v2/components/Timescale/Timeline';
import TwoAMTimeLine from '@/apps/mwd-v2/components/Timescale/TwoAMTimeLine';

type MiniMwdSvgProps = SVGProps<SVGSVGElement> & {
  children: ReactNode | ReactNode[];
  miniMwdHeight: number;
  miniMwdWidth: number;
};

const MiniMwdSvg: FC<MiniMwdSvgProps> = ({ children, miniMwdHeight, miniMwdWidth, ...svgProps }) => {
  const viewBox = useMemo(() => `0 0 ${miniMwdWidth} ${miniMwdHeight}`, [miniMwdHeight, miniMwdWidth]);
  return (
    <svg
      version='3'
      data-testid='miniMwdSvg'
      id='miniMwdSvg'
      viewBox={viewBox}
      width={miniMwdWidth}
      height={miniMwdHeight}
      {...svgProps}
    >
      <Timeline mini />
      <CurrentTimeLine mini chartHeight={miniMwdHeight} />
      <TwoAMTimeLine mini />
      {children}
    </svg>
  );
};
export default MiniMwdSvg;
